<template>
  <div id="RegisterDialog_main">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <el-tabs
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane
          label="Step 1. 掃描會議條碼／直接選擇戶別"
          name="1"
        >
          <div @click="init">
            <el-button
              class="householdSwitch"
              round
              @click="$refs.householdFrame.openNotShowVirtual() ; code = ''"
            >
              戶別選擇
            </el-button>
            <div
              class="img"
              alt="請掃描開通條碼、開通磁扣、會議條碼"
            />
            <p class="content_gray">
              您可以透過掃描以下資訊完成{{ actiontype }}
            </p>
            <span class="content">開通條碼、開通磁扣、會議條碼</span>
            <input
              v-model="hideData_account"
              type="text"
              name="user"
            ><!-- 不會使用 -->
            <input
              v-model="hideData_password"
              type="password"
              name="user"
            ><!-- 不會使用 -->
            <input
              id="input_code"
              ref="inputCode"
              v-model="code"
              type="password"
              autocomplete="off"
              @keyup.enter="sandCode"
              @blur="onblur"
            >
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'Step 2. 確認'+ actiontype +'資料'"
          name="2"
        >
          <div class="tabletName">
            {{ data.tabletName }}
          </div>
          <div v-if="data.name">
            {{ data.name }}
          </div>
          <div>{{ data.tabletArea }}坪（{{ data.tabletAreaRatio }}％）</div>
          <input
            ref="inputSubmit"
            v-model="identity"
            @keyup.enter="submit"
            @blur="onblur"
          >
          <div v-if="actiontype === '報到'">
            <div class="barcode">
              <VueBarcode
                value="myself"
                :options="barcodeOptions"
                tag="img"
              />
              <el-button
                type="primary"
                plain
                @click="identity = 'myself';submit()"
              >
                本人報到
              </el-button>
            </div>
            <div class="barcode">
              <VueBarcode
                value="entrust"
                :options="barcodeOptions"
                tag="img"
              />
              <el-button
                type="primary"
                plain
                @click="identity = 'entrust';submit()"
              >
                委託報到
              </el-button>
            </div>
          </div>
          <el-button
            v-else
            type="primary"
            class="unregisterButton"
            round
            @click="submit()"
          >
            確認{{ actiontype }}
          </el-button>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <HouseholdFrame
      ref="householdFrame"
      :open.sync="householdSwitch"
      @select-household="selectedHousehold"
    />
    <MultipleUnitOwnerDialog
      ref="multipleUnitOwnerDialog"
      @value-change="valueChange"
    />
  </div>
</template>
<script>
import HouseholdFrame from '@/components/HouseholdFrame'
import VueBarcode from '@chenfengyuan/vue-barcode'
import MultipleUnitOwnerDialog from './register/MultipleUnitOwnerDialog'

export default {
  components: {
    HouseholdFrame,
    VueBarcode,
    MultipleUnitOwnerDialog
  },
  data () {
    return {
      dialogVisible: false,
      actiontype: '報到', // 報到or簽退
      activeName: '1',
      presetMyself: true, // 是否開啟 預設本人報到（等於不顯示Step2）
      identity: '',
      code: '',
      data: {},
      householdSwitch: false,
      hideData_account: '', // 不會使用，騙chrome自動帶入帳號欄位
      hideData_password: '', // 不會使用，騙chrome自動帶入密碼欄位
      fromList: false, // true -> step2動作結束後，自動關閉彈窗
      canClickButton: true,
      barcodeOptions: {
        format: 'CODE39',
        width: 1.5,
        height: 50,
        displayValue: false
      }
    }
  },
  computed: {
    title () {
      if (this.activeName === '1' || this.presetMyself) { return '請掃描住戶會議條碼' + this.actiontype } else {
        if (this.actiontype === '報到') { return '請掃描條碼確認報到人身份' } else { return '請確認簽退戶別' }
      }
    }
  },
  watch: {
    householdSwitch () {
      if (this.householdSwitch === false) {
        this.$nextTick(() => {
          this.$refs.inputCode.focus()
        })
      }
    }
  },
  methods: {
    init () {
      this.canClickButton = true
      this.data = {}
      this.code = ''
      this.$nextTick(() => {
        this.$refs.inputCode.focus()
      })
      this.identity = this.presetMyself ? 'myself' : ''
    },
    openDialog (actiontype, data) {
      console.log(actiontype, data)
      this.actiontype = actiontype
      if (data) { // 從出席名單開啟彈窗
        this.data = data
        if (this.presetMyself) {
          this.identity = 'myself'
          this.submit()
          return
        }
        this.dialogVisible = true
        this.fromList = true
        this.data.name = this.data.unitOwnerName
        this.identity = ''
        this.$nextTick(() => {
          this.activeName = '2'
          this.$refs.inputSubmit.focus()
        })
      } else { // 從Dashboard開啟彈窗（批次報到、批次簽退）
        this.dialogVisible = true
        this.$nextTick(() => {
          this.activeName = '1'
        })
        this.init()
      }
    },
    checkTab (activeName, oldActiveName) {
      console.log(activeName, oldActiveName)
      this.code = ''
      if (this.presetMyself) {
        this.submit()
        return false
      } else {
        if (activeName > oldActiveName) { // 1 -> 2
          // eslint-disable-next-line eqeqeq
          if (Object.keys(this.data).length == 0) {
            this.$nextTick(() => {
              this.$refs.inputCode.focus()
            })
            return false
          }
          // 確認報到狀態是否合法
          this.code = ''
          console.log(this.data.registrationStatus)
          if (this.data.registrationStatus === 'Unregistered') {
            this.$message.error('此戶別已簽退')
            this.dialogVisible = !this.fromList
            return false
          }
          if (this.actiontype === '報到') {
            if (this.data.registrationStatus === 'Registered') {
              this.$message.error('此戶別已報到')
              return false
            } else {
              this.$nextTick(() => {
                this.$refs.inputSubmit.focus()
              })
            }
          } else {
            if (this.data.registrationStatus === 'NotRegistered') {
              this.$message.error('此戶別尚未報到')
              return false
            } else {
              this.$nextTick(() => {
                this.$refs.inputSubmit.focus()
              })
            }
          }
        } else { // 2 -> 1
          this.init()
        }
      }
    },
    // 選擇戶別完成
    selectedHousehold (content) {
      this.activeName = '1'
      // this.householdSwitch = false
      // 使用戶別id換區權戶id
      apiUnitOwnerAssembly.Register.GetUnitOwnerCardByTabletId(
        {
          AssemblyId: this.$route.params.id,
          TabletId: content.TabletId
        }
      ).then(res => {
        if (res.status === 200) {
          this.data = res.data
          this.data.tabletAreaRatio = (this.data.tabletAreaRatio * 100).toFixed(2)
          this.$nextTick(() => {
            this.activeName = '2'
            this.identity = ''
          })
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) {
          // eslint-disable-next-line eqeqeq
          if (err.response.data.description == '找不到此區權人') { this.$message.error('此戶別不在會議出席名單中，請先新增戶別後再執行' + this.actiontype) } else { this.$message.error(err.response.data.description) }
          this.$nextTick(() => {
            this.activeName = '1'
          })
          this.init()
        }
      })
    },
    // 掃描完會議條碼，取得step2報到資料
    sandCode () {
      if (!this.canClickButton) {
        this.code = ''
        return
      }
      this.canClickButton = false
      const Barcode = this.code.toUpperCase()
      this.code = ''
      if (Barcode === '') {
        this.canClickButton = true
        this.$message.warning('請掃描會議條碼')
        return
      }
      console.log(Barcode)
      apiUnitOwnerAssembly.Register.GetUnitOwnerCardListByMultipleWays(
        {
          AssemblyId: this.$route.params.id,
          Code: Barcode
        }
      ).then(res => {
        console.log(res)
        this.activeName = '1'
        if (res.status === 200) {
          const num = res.data.successUnitOwnerCards.length + res.data.failUnitOwnerCards.length
          // eslint-disable-next-line eqeqeq
          if (num == 0) {
            this.$message.error(this.actiontype + '失敗，請檢查出席名單並確認該戶別為區權戶。')
            // eslint-disable-next-line eqeqeq
          } else if (num == 1 && res.data.successUnitOwnerCards.length == 1) {
            this.data = res.data.successUnitOwnerCards[0]
            this.canClickButton = true
            this.submit()
          } else {
            this.$refs.multipleUnitOwnerDialog.openDialog(res.data, this.actiontype)
          }
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        if (err.response && err.response.status >= 400) {
          this.$message.error(err.response.data.title)
          this.$nextTick(() => {
            this.activeName = '1'
          })
          this.init()
        }
      })
    },
    // 確認報到、確認簽退
    submit () {
      // 不在此步驟防止連點以避免出錯，RegisterList 的遮罩已經會在得到 res 後 800 毫秒才關閉了。
      // if(this.canClickButton === false)
      //   return
      this.canClickButton = false
      this.identity = this.identity.toLowerCase()
      const requestData = {
        assemblyId: this.$route.params.id,
        unitOwnerId: this.data.id
      }
      if (this.actiontype === '報到') {
        if (this.identity === '') { this.identity = 'myself' }
        if (this.identity === 'myself') { // 本人報到
          apiUnitOwnerAssembly.Register.RegisterUnitOwner(
            requestData
          ).then(res => {
            if (res.status === 200) {
              this.$message.success(this.data.tabletName + '，此戶別報到成功！')
              this.finishStep2Action()
              this.valueChange('報到', this.data.id, '本人')
            }
          }).catch((err) => {
            console.log('錯誤訊息：', err.response)
            // eslint-disable-next-line eqeqeq
            if (err.response && err.response.status == 400) {
              this.$message.error(err.response.data.description)
              this.finishStep2Action()
            }
          })
        } else if (this.identity === 'entrust') { // 委託人報到
          apiUnitOwnerAssembly.Register.RegisterAgent(
            requestData
          ).then(res => {
            if (res.status === 200) {
              this.$message.success(this.data.tabletName + '，此戶別報到成功！')
              this.finishStep2Action()
              this.valueChange('報到', this.data.id, '委託')
            }
          }).catch((err) => {
            console.log('錯誤訊息：', err.response)
            if (err.response && err.response.status >= 400) {
              this.$message.error(this.data.tabletName + '，報到失敗！')
              this.finishStep2Action()
            }
          })
        } else {
          this.canClickButton = true
          this.identity = ''
        }
      }
      if (this.actiontype === '簽退') {
        apiUnitOwnerAssembly.Register.UnregisterUnitOwner(
          requestData
        ).then(res => {
          if (res.status === 200) {
            this.$message.success(this.data.tabletName + '，此戶別簽退成功！')
            this.finishStep2Action()
            this.valueChange('簽退', this.data.id)
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          // eslint-disable-next-line eqeqeq
          if (err.response && err.response.status == 400) {
            this.$message.error(err.response.data.description)
            this.finishStep2Action()
          }
        })
      }
    },
    // 出席統計表同步更新，未來串SignalR會捨棄
    valueChange (actiontype, id, identity) {
      // 報到人數增加
      // eslint-disable-next-line eqeqeq
      if (actiontype == '報到') {
        this.$emit('tablet-value-add', id, identity)
        this.$emit('tablet-value-dashboard-add', id, identity)
      } else {
        this.$emit('unregister-value-add', id)
        this.$emit('unregister-value-dashboard-add', id)
      }
    },
    finishStep2Action () {
      this.identity = ''
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
      if (this.fromList) {
        this.dialogVisible = false
      } else {
        this.activeName = '1'
      }
    },
    onblur () {
      console.log('onblur')
      if (this.dialogVisible) {
        if (this.activeName === '1' && !this.householdSwitch) {
          this.init()
        } else if (this.activeName === '2') {
          this.$nextTick(() => {
            this.$refs.inputSubmit.focus()
          })
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#RegisterDialog_main
  ::v-deep .el-dialog
    +basicDialog
    .el-dialog__body
      padding-top: 25px
      padding-bottom: 40px
  ::v-deep .el-tabs
    .el-tabs__header
      display: none
    #pane-1
      h2
        font-weight: bold
        font-size: 30px
        margin: 20px 0 10px 0
        color: $mainFontColor
      .img
        height: 200px
        background-size: contain
        background-position: center center
        background-repeat: no-repeat
        margin: 40px auto
        background-image: url('../../../assets/img/unitOwnerAssembly/teaching.png')
      .content_gray
        font-size: 21px
        color: $subFontColor
        font-weight: 600
        margin-bottom: 17px
      .content
        font-size: 25px
        color: $mainFontColor
        font-weight: 600
      .householdSwitch
        float: right
        position: relative
        top: -40px
    #pane-2
      div
        font-size: 25px
        line-height: 60px
        font-weight: 500
      .tabletName
        color: $mainColor
      .barcode
        display: inline-block
        margin: 0 20px
        img
          display: block
        .el-button
          font-size: 18px
      .unregisterButton
        margin-top: 20px
    input
      position: absolute
      opacity: 0
      width: 1px
</style>
